<template>
  <main class="flex-1 overflow-hidden">
    <div class="flex h-screen flex-col overflow-hidden">
      <header class="border-b bg-background p-4">
        <div class="flex items-center justify-between">
          <div>
            <h1 class="text-2xl font-bold">WhatsApp Alert Notifications</h1>
            <p class="text-muted-foreground">
              Configure WhatsApp alerts with escalation rules and acknowledgment
              tracking
            </p>
          </div>
          <el-button
            @click="handleCreateRule()"
            type="primary"
            icon="el-icon-plus"
            class="h-10 px-4 py-2"
          >
            Create Alert Rule
          </el-button>
        </div>
      </header>
      <div class="flex flex-col flex-1 overflow-hidden p-6">
        <CountPanel />
        <div class="flex-1 flex flex-col">
          <div class="flex items-center justify-between mb-4">
            <TabsWhatsApp v-model="tabId" />
            <div class="flex items-center gap-2">
              <div class="relative">
                <el-input
                  placeholder="Search..."
                  prefix-icon="el-icon-search"
                  class="w-[250px]"
                  clearable
                  v-model="searchText"
                />
              </div>
              <SmartSelect
                v-if="tabId === 'alert-rules'"
                v-model="runStatus"
                :add-all-option="{ id: null, value: 'All Status' }"
                :options="[
                  { id: 1, name: 'Enabled' },
                  { id: 0, name: 'Disabled' },
                ]"
                class="w-[120px]"
              />
            </div>
          </div>
          <AlertRules
            v-if="tabId === 'alert-rules'"
            class="flex-1"
            ref="alertRuleListViewRef"
            :searchText="searchText"
            :statusFilter="runStatus"
          />
          <AlertHistory
            v-else-if="tabId === 'alert-history'"
            class="flex-1"
            :searchText="searchText"
          />
          <RecipientsView
            v-else-if="tabId === 'recipients'"
            class="flex-1"
            :searchText="searchText"
          />
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import CountPanel from "./CountPanel.vue";
import TabsWhatsApp from "./TabsWhatsApp.vue";
import SmartSelect from "@/components/SmartControls/SmartSelect.vue";
import AlertRules from "./AlertRules.vue";
import AlertHistory from "./AlertHistory.vue";
import RecipientsView from "./RecipientsView.vue";
export default {
  name: "WhatsAppView",
  components: {
    CountPanel,
    TabsWhatsApp,
    SmartSelect,
    AlertRules,
    AlertHistory,
    RecipientsView,
  },
  emits: ["input"],
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      tabId: "alert-rules",
      searchText: "",
      runStatus: "all",
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
    async handleCreateRule() {
      await this.$loaderWindow({
        title: `Edit Alert Rule`,
        component: () => import("./EditWhatsAppAlert.vue"),
        width: "70%",
        showHeader: false,
        padding: false,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        props: {},
      });
      this.$refs.alertRuleListViewRef?.refreshList();
    },
  },
};
</script>
<style lang="scss" scoped>
.whats-app-view {
  flex: 1;
  display: flex;
  flex-direction: column;
}
</style>
